import React, { useContext, useEffect, useState, useCallback } from "react";
import styled from "styled-components";
import { Trans, useTranslation } from "react-i18next";
import { Button, Panel, Input } from "components/bootstrap";
import FormWrap from "integrations/aws/common/FormWrap";
import SkipHealthCheck from "integrations/aws/common/SkipHealthCheck";
import useFetch from "integrations/hooks/useFetch";
import { ApiRoutes } from "integrations/aws/common/Routes";
import Countdown from "integrations/aws/common/Countdown";
import { KINESIS_LOG_TYPES } from "integrations/aws/common/constants";
import { ApiContext } from "integrations/aws/context/Api";
import FormDataContext from "integrations/contexts/FormDataContext";
import Icon from "components/common/Icon";
import { toAWSRequest } from "integrations/aws/common/formDataAdapter";
const Notice = styled.span`
  display: flex;
  align-items: center;

  > span {
    margin-left: 6px;
  }
`;
const CheckAgain = styled.p`
  display: flex;
  align-items: center;

  > strong {
    margin-right: 9px;
  }
`;
const StepHealthCheck = ({ onChange, onSubmit }) => {
  const { t } = useTranslation("integrations");
  const { logData, setLogData } = useContext(ApiContext);
  const { formData } = useContext(FormDataContext);
  const [pauseCountdown, setPauseCountdown] = useState(false);
  const [fetchStreamArnStatus, setStreamArnFetch] = useFetch(
    null,
    (response) => {
      onChange({ target: { name: "awsCloudwatchKinesisStreamArn", value: response.result } });
    },
    "POST",
    toAWSRequest(formData, {
      region: formData.awsCloudWatchAwsRegion.value,
      stream_name: formData.awsCloudWatchKinesisStream.value
    })
  );
  useEffect(() => {
    setStreamArnFetch(ApiRoutes.INTEGRATIONS.AWS.KINESIS.STREAM_ARN);
  }, [setStreamArnFetch]);
  useEffect(() => {
    if (fetchStreamArnStatus.error) {
    }
  }, [fetchStreamArnStatus]);
  const [logDataProgress, setLogDataUrl] = useFetch(
    null,
    (response) => {
      setLogData(response);
      onChange({ target: { name: "awsCloudWatchKinesisInputType", value: response.type } });
    },
    "POST",
    toAWSRequest(formData, {
      region: formData.awsCloudWatchAwsRegion.value,
      stream_name: formData.awsCloudWatchKinesisStream.value
    })
  );
  const checkForLogs = useCallback(() => {
    setPauseCountdown(true);
    setLogDataUrl(ApiRoutes.INTEGRATIONS.AWS.KINESIS.HEALTH_CHECK);
  }, [setPauseCountdown, setLogDataUrl]);
  useEffect(() => {
    if (!logData) {
      checkForLogs();
    }
  }, [checkForLogs, logData]);
  useEffect(() => {
    if (!logDataProgress.loading && !logDataProgress.data) {
      setPauseCountdown(false);
      setLogDataUrl(null);
    }
  }, [logDataProgress.data, logDataProgress.loading, setLogDataUrl]);
  if (!logData) {
    return /* @__PURE__ */ React.createElement(
      Panel,
      {
        bsStyle: "warning",
        header: /* @__PURE__ */ React.createElement(Notice, null, /* @__PURE__ */ React.createElement(Icon, { name: "warning", size: "2x" }), /* @__PURE__ */ React.createElement("span", null, t("aws_step_health_check.no_response_title")))
      },
      /* @__PURE__ */ React.createElement("p", null, t("aws_step_health_check.waiting_description")),
      /* @__PURE__ */ React.createElement(CheckAgain, null, /* @__PURE__ */ React.createElement("strong", null, /* @__PURE__ */ React.createElement(
        Trans,
        {
          t,
          i18nKey: "aws_step_health_check.checking_again_in",
          components: {
            countdown: /* @__PURE__ */ React.createElement(Countdown, { timeInSeconds: 120, callback: checkForLogs, paused: pauseCountdown })
          }
        }
      )), /* @__PURE__ */ React.createElement(Button, { type: "button", bsStyle: "primary", bsSize: "sm", onClick: checkForLogs, disabled: logDataProgress.loading }, logDataProgress.loading ? t("aws_step_health_check.checking_button") : t("aws_step_health_check.check_now_button"))),
      /* @__PURE__ */ React.createElement("p", null, /* @__PURE__ */ React.createElement("em", null, t("aws_step_health_check.do_not_refresh"))),
      /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(SkipHealthCheck, { onSubmit, onChange }))
    );
  }
  const handleSubmit = () => {
    onSubmit();
    onChange({ target: { name: "awsCloudWatchKinesisInputType", value: logData.type } });
  };
  const logTypeLabel = KINESIS_LOG_TYPES.find((type) => type.value === logData.type).label;
  return /* @__PURE__ */ React.createElement(
    FormWrap,
    {
      onSubmit: handleSubmit,
      buttonContent: t("aws_step_health_check.review_button"),
      disabled: false,
      title: t("aws_step_health_check.title"),
      description: /* @__PURE__ */ React.createElement("p", null, t("aws_step_health_check.sample_description", { logType: logTypeLabel }))
    },
    /* @__PURE__ */ React.createElement(
      Input,
      {
        id: "awsCloudWatchLog",
        type: "textarea",
        label: t("aws_step_health_check.formatted_log_label"),
        value: logData.message || t("aws_step_health_check.no_messages"),
        rows: 10,
        disabled: true
      }
    )
  );
};
export default StepHealthCheck;
